/* Angular Component */
import {
  Component,
  Input,
  Output,
  EventEmitter,
  OnInit,
  OnDestroy,
  ChangeDetectorRef,
} from "@angular/core";
import { Subscription } from "rxjs";
import { Socket } from "../../../infrastructure/socket.service";
import { MediaInfo, ContentAnalysisResult } from "../../../domain/media";
import { IUploadFile } from "../../../domain/Upload/i-upload-file";

@Component({
  selector: "library-uploader",
  templateUrl: "./libraryUploader.component.html",
  styleUrls: ["./libraryUploader.component.scss"],
})
export class LibraryUploaderComponent implements OnInit, OnDestroy {
  @Input()
  uploadFile: IUploadFile;

  @Output()
  remove = new EventEmitter<number>();

  @Output()
  success = new EventEmitter<MediaInfo>();

  contentUploadResult: { mediaId: number; mediaUid: string };
  analyzingResult: MediaInfo;

  completeSubscription: Subscription;
  socketSubscription: Subscription;
  progressChangeSubscription: Subscription;

  reportCta = "REPORT";

  constructor(
    private socketService: Socket,
    private changeDetectorRef: ChangeDetectorRef,
  ) {}

  onRemove() {
    if (!this.uploadFile.isComplete) {
      this.uploadFile.abort();
    }

    this.remove.emit(
      this.contentUploadResult ? this.contentUploadResult.mediaId : undefined,
    );
  }

  isUploadSuccess() {
    return (
      this.uploadFile.isComplete &&
      (!this.analyzingResult ||
        this.analyzingResult.contentAnalysisResult === ContentAnalysisResult.Ok)
    );
  }

  isUploadSuccessHidden() {
    return !this.isUploadSuccess();
  }

  isFailure() {
    return (
      this.uploadFile.isError ||
      (this.analyzingResult &&
        this.analyzingResult.contentAnalysisResult !== ContentAnalysisResult.Ok)
    );
  }

  isFailureHidden() {
    return !this.isFailure();
  }

  /**
   * Send Report about error
   * @return void
   */
  uploadFailedReport(event) {
    event.preventDefault();

    //var fileDetails = this.uploadFile;
    //delete fileDetails['file'];

    //console.log("Sending Report About Failure", JSON.stringify(fileDetails));

    this.reportCta = "THANK YOU!";

    setTimeout(
      (() => {
        this.reportCta = "";
      }).bind(this),
      3000,
    );
  }

  formatProgress() {
    return (this.uploadFile.progress * 100).toFixed(0);
  }

  ngOnInit() {
    this.completeSubscription = this.uploadFile.isCompleteChange.subscribe(
      (contentUploadResult) => {
        this.contentUploadResult = contentUploadResult;
      },
    );

    this.progressChangeSubscription = this.uploadFile.progressChange.subscribe(
      (x) => {
        this.changeDetectorRef.markForCheck();
      },
    );

    this.socketSubscription = this.socketService.uploadFinishedChange.subscribe(
      (result) => {
        if (
          !this.contentUploadResult ||
          this.contentUploadResult.mediaId !== result.id
        ) {
          return;
        }

        this.analyzingResult = result;

        if (result.contentAnalysisResult === ContentAnalysisResult.Ok) {
          this.success.emit(result);
        }
      },
    );
  }

  ngOnDestroy() {
    if (this.completeSubscription) {
      this.completeSubscription.unsubscribe();
    }

    if (this.socketSubscription) {
      this.socketSubscription.unsubscribe();
    }

    if (this.progressChangeSubscription) {
      this.progressChangeSubscription.unsubscribe();
    }
  }
}
